export const MAX_WIDTH_MESSAGE_DESKTOP = 480;

export const MAX_WIDTH_MESSAGE_MOBILE = 315;
